import { Input,Component, inject } from '@angular/core';
import { signal, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, NavigationEnd } from '@angular/router';
import { filter, map } from 'rxjs';
import { SideMenu } from '../../../models/menu.model';
import { configStore } from '../../../stores/config.store';
import {MatIconModule} from '@angular/material/icon';
import { MatDrawer } from '@angular/material/sidenav';
@Component({
  selector: 'app-side-bar',
  imports: [MatIconModule],
  standalone: true,
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss']
})
export class SideBarComponent {
  private router = inject(Router);
  private configStore = inject(configStore);
  @Input()side_drawer!:MatDrawer;
  
  module = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(event => {
        const moduleFromUrl = event.url.split('/')[1];
        return moduleFromUrl || '';
      })
    ),
    { initialValue: '' }
  );

  selectedRoute = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(event => event.url)
    ),
    { initialValue: '' }
  );

  sideMenuSignal = signal<SideMenu[]>([
    {
      module: 'projects',
      menu_name: 'Dashboard',
      menu_icon: 'dashboard-icon',
      route: '/projects'
    },
    {
      module: 'projects',
      menu_name: 'Projects',
      menu_icon: 'project-icon',
      route: '/projects/list'
    },
    {
      module: 'projects',
      menu_name: 'Users',
      menu_icon: 'user-icon',
      route: '/projects/users'
    },    
    {
      module: 'eruauth',
      menu_name: 'Dashboard',
      menu_icon: 'dashboard-icon',
      route: `/eruauth/${this.configStore.currentProject()}/${this.configStore.currentEnv()}`
    },
    {
      module: 'eruauth',
      menu_name: 'Authorizers',
      menu_icon: 'authorizer-icon',
      route: `/eruauth/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/authorizers`
    },
    {
      module:'eruauth',
      menu_name:'Settings',
      menu_icon:'settings-icon',
      route: `/eruauth/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/settings`
    },
    {
      module: 'eruauth',
      menu_name: 'Variables',
      menu_icon: 'variables-icon',
      route: `/eruauth/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/variables`
    },
    {
      module: 'erufiles',
      menu_name: 'Dashboard',
      menu_icon: 'dashboard-icon',
      route: `/erufiles/${this.configStore.currentProject()}/${this.configStore.currentEnv()}`
    },
    {
      module: 'erufiles',
      menu_name: 'Storage',
      menu_icon: 'storage-icon',
      route: `/erufiles/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/storages`
    },
    {
      module: 'erufiles',
      menu_name: 'Keys',
      menu_icon: 'key-icon',
      route: `/erufiles/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/keys`
    },
    {
      module: 'erufiles',
      menu_name: 'Variables',
      menu_icon: 'variables-icon',
      route: `/erufiles/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/variables`
    },
    {
      module:'erufiles',
      menu_name:'Settings',
      menu_icon:'settings-icon',
      route: `/erufiles/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/settings`
    },
    {
      module: 'erufunctions',
      menu_name: 'Dashboard',
      menu_icon: 'dashboard-icon',
      route: `/erufunctions/${this.configStore.currentProject()}/${this.configStore.currentEnv()}`
    },
    {
      module: 'erufunctions',
      menu_name: 'Functions',
      menu_icon: 'eru-functions',
      route: `/erufunctions/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/list`
    },{
      module:'erufunctions',
      menu_name:'Settings',
      menu_icon:'settings-icon',
      route: `/erufunctions/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/settings`
    },
    {
      module: 'erufunctions',
      menu_name: 'Variables',
      menu_icon: 'variables-icon',
      route: `/erufunctions/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/variables`
    },
    {
      module:'eruai',
      menu_name:'Dashboard',
      menu_icon:'dashboard-icon',
      route: `/eruai/${this.configStore.currentProject()}/${this.configStore.currentEnv()}`

    },{
      module: 'eruai',
      menu_name: 'Tenants',
      menu_icon: 'authorizer-icon',
      route: `/eruai/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/tenants`
    },{
      module: 'eruai',
      menu_name: 'Models',
      menu_icon: 'authorizer-icon',
      route: `/eruai/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/models`
    },{
      module: 'eruai',
      menu_name: 'Tools',
      menu_icon: 'authorizer-icon',
      route: `/eruai/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/tools`
    },{
      module: 'eruai',
      menu_name: 'Agents',
      menu_icon: 'authorizer-icon',
      route: `/eruai/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/agents`
    },{
      module: 'eruai',
      menu_name: 'Vectors',
      menu_icon: 'authorizer-icon',
      route: `/eruai/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/vectors`
    },
    {
      module: 'eruai',
      menu_name: 'Settings',
      menu_icon:'settings-icon',
      route: `/eruai/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/settings`
    },
    {
      module:'eruai',
      menu_name:'Variables',
      menu_icon:'variables-icon',
      route: `/eruai/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/variables`
    },
    {
      module: 'erugateway',
      menu_name: 'Dashboard',
      menu_icon: 'dashboard-icon',
      route: `/erugateway/${this.configStore.currentProject()}/${this.configStore.currentEnv()}`
    },
    {
      module: 'erugateway',
      menu_name: 'Authorizers',
      menu_icon: 'authorizer-icon',
      route: `/erugateway/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/authorizer-list`
    },
    {
      module: 'erugateway',
      menu_name: 'Listener Rules',
      menu_icon: 'variables-icon',
      route: `/erugateway/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/rule-list`
    },{
      module:'erugateway',
      menu_name:'Settings',
      menu_icon:'settings-icon',
      route: `/erugateway/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/settings`
      
    },
    {
      module: 'eruql',
      menu_name: 'Dashboard',
      menu_icon: 'dashboard-icon',
      route: `/eruql/${this.configStore.currentProject()}/${this.configStore.currentEnv()}`
    },
    {
      module: 'eruql',
      menu_name: 'Database',
      menu_icon: 'ql-icon',
      route: `/eruql/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/database`
    },
    {
      module: 'eruql',
      menu_name: 'My Queries',
      menu_icon: 'my-query-icon',
      route: `/eruql/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/myqueries`
    },
    {
      module:'eruql',
      menu_name:'Settings',
      menu_icon:'settings-icon',
      route: `/eruql/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/settings`
    },
    {
      module: 'eruql',
      menu_name: 'Variables',
      menu_icon: 'variables-icon',
      route: `/eruql/${this.configStore.currentProject()}/${this.configStore.currentEnv()}/variables`
    },
  ],{

  });

  sideMenu = computed(() =>
    this.sideMenuSignal().filter((menu) => menu.module === this.module())
  );

  selectedMenu = computed(() =>
    this.sideMenuSignal().find((menu) => menu.route === this.selectedRoute())
  );

  navigate(event: Event) {
    const element = event.target as HTMLElement;
    const routeElement = element.closest('[data-route]');
    if (routeElement) {
      const route = routeElement.getAttribute('data-route');
      this.router.navigate([route]);
    }
  }
}